import React from 'react'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import UISelect from 'components/shared/UISelect'

import PlaybookModal from '../PlaybookModal'

import singleSrc from '!svg-inline!images/svg/single-routing.svg'
import globalSrc from '!svg-inline!images/svg/global-routing.svg'
import groupSrc from '!svg-inline!images/svg/group-routing.svg'
import noRoutingSrc from '!svg-inline!images/svg/no-routing.svg'

import style from './style.styl'

const GoalRoutingModal = ({
  onCloseClick,
  onCancelClick,
  onSingleRouteUserSelect,
  onGroupRouteUserSelect,
  handleSelectSingle,
  handleSelectGlobal,
  handleSelectGroup,
  handleSelectNoRouting,
  isSingleRoutingSelected,
  isGroupRoutingSelected,
  isGlobalRoutingSelected,
  isNoRoutingSelected,
  resetRoutingView,
  viewSingleRoutingOptions,
  viewGroupRoutingOptions,
  viewGlobalRoutingOptions,
  classificationDetails,
  orgUsersOptions,
  selectedGoalRoutingOption,
  selectedRoutingUsers,
  firstUser,
}) => (
  <PlaybookModal
    title="Goal Routing"
    onCancelClick={onCancelClick}
    cancelLabel="Cancel"
    onCloseClick={onCloseClick}
    closeLabel="Update"
    showSaveStatus={false}
    description={_.get(classificationDetails, 'label', '...')}
    contentClassName={style.GoalRoutingModalContent}
    headerClassName={style.GoalRoutingModalHeader}
  >
    {(viewSingleRoutingOptions || viewGlobalRoutingOptions || viewGroupRoutingOptions) && (
      <div className="return-to-routing-link" onClick={resetRoutingView}>
        &lt; Back to Routing
      </div>
    )}
    <div className="goal-routing-wrapper drift-form flex-column">
      <div className="goal-routing-cta">How would you like to route conversations?</div>
      <div>
        {!viewGroupRoutingOptions &&
        !viewGlobalRoutingOptions && (
          <div
            className={cx({ selected: isSingleRoutingSelected }, 'goal-routing-choice', 'flex')}
            onClick={handleSelectSingle}
          >
            <IconSVG className="action-icon" src={singleSrc} />
            <div className="flex-column">
              <strong>To a single teammate</strong>
              <p>
                Select a single teammate to be added to and notified of each conversation once this
                goal is met.
              </p>
            </div>
          </div>
        )}
        {!viewSingleRoutingOptions &&
        !viewGlobalRoutingOptions && (
          <div
            className={cx({ selected: isGroupRoutingSelected }, 'goal-routing-choice', 'flex')}
            onClick={handleSelectGroup}
          >
            <IconSVG className="action-icon" src={groupSrc} />
            <div className="flex-column">
              <strong>Round robin within a group</strong>
              <p>
                Select a group of teammates to alternate between when adding participants to a
                conversation.
              </p>
            </div>
          </div>
        )}
        {!viewSingleRoutingOptions &&
        !viewGroupRoutingOptions && (
          <div
            className={cx({ selected: isGlobalRoutingSelected }, 'goal-routing-choice', 'flex')}
            onClick={handleSelectGlobal}
          >
            <IconSVG className="action-icon" src={globalSrc} />
            <div className="flex-column">
              <strong>Based on Conversation routing rules</strong>
              <p>Determine who is added to a conversation by referencing your Conversation routing rules.</p>
            </div>
          </div>
        )}
        {!viewGlobalRoutingOptions &&
        !viewSingleRoutingOptions &&
        !viewGroupRoutingOptions && (
          <div
            className={cx({ selected: isNoRoutingSelected }, 'goal-routing-choice', 'flex')}
            onClick={handleSelectNoRouting}
          >
            <IconSVG className="action-icon" src={noRoutingSrc} />
            <div className="flex-column">
              <strong>Do not route this conversation</strong>
              <p>Don’t add anyone from my team to this conversation.</p>
            </div>
          </div>
        )}

        {viewSingleRoutingOptions && (
          <div className="routing-options">
            <div className="goal-routing-cta">Who would you like to route to?</div>
            <UISelect
              className="skip-select"
              options={orgUsersOptions}
              value={selectedGoalRoutingOption.userId || 0}
              onChange={onSingleRouteUserSelect}
              filterOption={(option, filterText) =>
                getDisplayName(option.user)
                  .toLowerCase()
                  .includes(filterText)}
            />
          </div>
        )}
        {viewGroupRoutingOptions && (
          <div className="routing-options">
            <div className="goal-routing-cta">Who would you like to route to?</div>
            <UISelect
              multi={true}
              className="skip-select"
              options={orgUsersOptions}
              value={selectedRoutingUsers || [firstUser.id]}
              onChange={onGroupRouteUserSelect}
              filterOption={(option, filterText) =>
                getDisplayName(option.user)
                  .toLowerCase()
                  .includes(filterText)}
            />
          </div>
        )}
        {viewGlobalRoutingOptions && (
          <div className="routing-options">
            <div className="goal-routing-cta">Here are your current routing rules:</div>
            <p>[regions, etc. here!]</p>
          </div>
        )}
      </div>
    </div>
  </PlaybookModal>
)

export default GoalRoutingModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/GoalRoutingModal/component.js